/**
 * The one public read the browser still makes (canon `contracts/API.md` § Public reads).
 *
 * The homepage used to fetch five. Canon decision `D-015` moved four of them — the board,
 * the weekly and monthly click rankings, and the Founding cohort — to **build time**: they
 * are read once by `scripts/site-data/reads.mjs` and embedded in the bundle, so a visitor's
 * page load issues no request for them (`WEB-039`, `src/site-data.ts`).
 *
 * What is left is tomorrow's auction, and it is left deliberately. It is the only part of the
 * page whose subject moves within a display day — canon § 7 locks the board's positions for
 * the whole of it — and the only place a countdown is measured, which needs a `serverTime`
 * fresher than a build's.
 *
 * A bare `GET` with no query parameter: the display date is derived from core's UTC clock
 * (canon § 8), so two visitors in different timezones see the same auction and neither can
 * ask for a window of their own.
 *
 * A module-level function on purpose — `useApiResource` keys its effect on the loader's
 * identity, and a function defined inside a component would refetch on every render.
 */
import { getJson } from "./client";
import type { AuctionResponse } from "./types";

export function fetchTomorrowAuction(signal?: AbortSignal): Promise<AuctionResponse> {
  return getJson<AuctionResponse>("/v1/auction/tomorrow", signal);
}
